import { RiCloseLine } from "@react-icons/all-files/ri/RiCloseLine";
import { VscTriangleUp } from "@react-icons/all-files/vsc/VscTriangleUp";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import Typewriter from "typewriter-effect";
import Snake from "../components/snake";

export default function Home() {
  const [score, setScore] = useState();
  const [pressed, setPressed] = useState([]);
  const ALLOWED_KEYS = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];

  function handleSetScore(value) {
    setScore(value);
  }

  useEffect(() => {
    const handleKeyDown = (event) => {
      const { key } = event;
      if (ALLOWED_KEYS.includes(key)) {
        setPressed((prevPressed) => {
          if (!prevPressed.includes(key)) {
            return [...prevPressed, key];
          }
          return prevPressed;
        });
      }
    };

    const handleKeyUp = (event) => {
      const { key } = event;
      setPressed((prevPressed) => prevPressed.filter((k) => k !== key));
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("keyup", handleKeyUp);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("keyup", handleKeyUp);
    };
  }, [ALLOWED_KEYS]);

  return (
    <motion.div
      className="w-full h-full bg-radial bg-no-repeat bg-right"
      initial={{ y: 50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -50, opacity: 0 }}
    >
      <div className="flex items-center justify-center h-full max-w-7xl mx-auto px-2">
        <div className="lg:w-1/2 w-full mx-10 lg:ml-10 flex flex-col justify-between h-[80%] lg:h-auto">
          <div className="mb-20">
            <p className="text-white text-lg">Bienvenido 👋, Soy</p>
            <h1 className="text-white lg:text-6xl md:text-5xl text-5xl">
              Camilo Rivera
            </h1>

            <h2 className="text-[#8900FF] lg:text-3xl md:text-2xl text-xl flex items-center gap-3">
              <span className="animate-pulse">&#62;</span>
              <Typewriter
                options={{
                  loop: true,
                  wrapperClassName:
                    "text-[#6EC1E4] lg:text-2xl md:text-2xl text-xl gap-3",
                  cursorClassName:
                    "text-[#6EC1E4] lg:text-2xl md:text-2xl text-xl gap-3",
                }}
                onInit={(typewriter) => {
                  typewriter
                    .typeString("Full Stack Web Developer Junior")
                    .pauseFor(1000)
                    .deleteAll()
                    .typeString("Freelancer")
                    .pauseFor(500)
                    .start();
                }}
              />
            </h2>
          </div>

          <div className="flex flex-col gap-2.5">
            <p className="text-[#607B96]">
              {/* También puedes ver mi repositorio de Github */}
            </p>
            <p>
              <span className="text-[#4D5BCE]">const</span>{" "}
              <span className="text-[#43D9AD]">linkGithub</span>{" "}
              <span className="text-white">=</span>{" "}
              <a
                href="https://github.com/JCamiloRiveraP"
                target="_blank"
                rel="noreferrer"
              >
                <span className="text-[#E99287] text-wrap lg:break-normal md:break-all sm:break-all">
                  "https://github.com/JCamiloRiveraP"
                </span>
              </a>
            </p>
            <p className="pt-10">
              <span className="text-cyan-400 bg-clip-text font-light">By </span>
              <span className="bg-gradient-to-r from-cyan-400 to-violet-600 bg-clip-text text-transparent font-semibold">
                Juan Pulido
              </span>{" "}
              🐺
            </p>
          </div>
        </div>

        <div className="w-1/2 overflow-hidden max-h-[90%] hidden lg:block mr-10">
          <div className="border border-[#0C1616] bg-gradient-to-br from-[#175553] to-[#43D9AD]/10 rounded-lg p-[35px] backdrop-blur-[32px] relative flex gap-6 items-start justify-center">
            <div className="w-1/2 bg-[#263746] rounded-lg inner-shadow-snake">
              <Snake scoreSnake={handleSetScore} />
            </div>

            <div className="w-1/2 h-full flex flex-col items-center justify-center">
              <div className="bg-[#01142330] rounded-lg p-3 text-white mb-5">
                <div className="mb-4">
                  <p>// usa el teclado</p>
                  <p>// flechas</p>
                </div>

                <div className="grid grid-cols-3 grid-rows-2 gap-1">
                  <div
                    className={`col-span-3 col-start-2 border border-[#1E2D3D] rounded-lg w-max py-2.5 px-5 transition-all shadow-sm shadow-[#607B96] ${
                      pressed.includes("ArrowUp")
                        ? "scale-105 bg-[#071c2e]"
                        : "bg-[#010C15]"
                    }`}
                  >
                    <VscTriangleUp />
                  </div>

                  <div
                    className={`border border-[#1E2D3D] rounded-lg w-max py-2.5 px-5 transition-all shadow-sm shadow-[#607B96] ${
                      pressed.includes("ArrowLeft")
                        ? "scale-105 bg-[#071c2e]"
                        : "bg-[#010C15]"
                    }`}
                  >
                    <VscTriangleUp className="-rotate-90" />
                  </div>

                  <div
                    className={`border border-[#1E2D3D] rounded-lg w-max py-2.5 px-5 transition-all shadow-sm shadow-[#607B96] ${
                      pressed.includes("ArrowDown")
                        ? "scale-105 bg-[#071c2e]"
                        : "bg-[#010C15]"
                    }`}
                  >
                    <VscTriangleUp className="rotate-180" />
                  </div>

                  <div
                    className={`border border-[#1E2D3D] rounded-lg w-max py-2.5 px-5 transition-all shadow-sm shadow-[#607B96] ${
                      pressed.includes("ArrowRight")
                        ? "scale-105 bg-[#071c2e]"
                        : "bg-[#010C15]"
                    }`}
                  >
                    <VscTriangleUp className="rotate-90" />
                  </div>
                </div>
              </div>

              <div className="self-start text-white">
                <p>// puntaje : {score}</p>
              </div>
            </div>

            <div>
              <div className="x-button-snake p-1 w-max rounded-full top-3 left-3 absolute">
                <RiCloseLine className="text-[#48b3aa] text-[12px]" />
              </div>
              <div className="x-button-snake p-1 w-max rounded-full top-3 right-3 absolute">
                <RiCloseLine className="text-[#48b3aa] text-[12px]" />
              </div>
              <div className="x-button-snake p-1 w-max rounded-full bottom-3 right-3 absolute">
                <RiCloseLine className="text-[#48b3aa] text-[12px]" />
              </div>
              <div className="x-button-snake p-1 w-max rounded-full bottom-3 left-3 absolute">
                <RiCloseLine className="text-[#48b3aa] text-[12px]" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
